import React, { Suspense, lazy, useEffect } from "react";
// import {  BrowserRouter } from 'react-router-dom';
import { Box, CssBaseline } from "@mui/material";
import Layout from "./components/Layout";
import { BrowserRouter, Routes, Route, Navigate } from "react-router";
import Home from "./pages/Home";
import { CustomBreadcrumbProvider } from "./contexts/CustomBreadcrumb";
import BreadcrumbsComponent from "./components/BreadcrumbsComponent";
import { AvatarProvider } from "./contexts/AvatarContext";
import MyThoughtCoCreate from "./pages/MyThoughtCoCreate/MyThoughtCoCreate";
import { ThoughtCoCreateProvider } from "./contexts/ThoughtCoCreateContext";
import SubmissionsDashboard from "./pages/MyThoughtCoCreate/Dashboard";
import Deliverable from "./pages/MyThoughtCoCreate/Deliverable";
import EducatorDashboard from "./pages/Dashboard/Home";
import LearningTool from "./pages/LearningTool/LearningTool";
import Twinspace from "./pages/MyTwinspace/MyTwinspace";
import { TwinspaceLayout } from "./pages/MyTwinspace/Layout";
import UserProfile from "./pages/UserProfile/Profile";
import { UserProfileLayout } from "./pages/UserProfile/Layout";
import EducatorRegisterLayout from "./components/EducatorRegisterLayout";
import RegisterForm from "./pages/RegisterForm";
import TopicDetail from "./pages/Forum/DiscussionDetail";
import ForumDetail from "./pages/Forum/ForumDetail";
import DiscussionDetail from "./pages/Forum/DiscussionDetail";
import TCCScoringSystemLayout from "./pages/TCCScoringSystem/Layout";
import ScoringSystem from "./pages/TCCScoringSystem/ScoringSystem";
import ResultSummary from "./pages/TCCScoringSystem/Result";
import ThoughtCoCreateLayout from "./pages/ThoughtCoCreate/ThoughtCoCreateLayout";
import RulesAndGuidelinesPage from "./pages/ThoughtCoCreate/rules-and-guidelines/page";
import RulesAndGuidelinesLayout from "./pages/ThoughtCoCreate/rules-and-guidelines/layout";
import Dashboard from "./pages/Organizer/page";
import { SiteAlertProvider } from "./contexts/SiteAlertContext";
import TCCSummitFinalistPage from "./pages/SummitFinalist/summit-finalist";
import TCCSummitLanding from "./pages/SummitFinalist/summit-page";
import AllCoursesPage from "./pages/MyCourse/MyCourse";
import EducatalystLayout from "./pages/Educatalyst/Layout";
import { WorkshopProvider } from "./contexts/WorkshopContext";
import WorkshopCreation from "./pages/Educatalyst/WorkshopCreation";
import WorkshopHub from "./pages/Educatalyst/page";
import WorkshopDetail from "./pages/Educatalyst/WorkshopDetail";
import EditWorkshop from "./pages/Educatalyst/EditWorkshop";
import WorkshopAdminDetail from "./pages/Workshop/components/WorkshopAdminDetail";
import ProposalDetail from "./pages/Educatalyst/ProposalDetail";
import Dashboard2 from './pages/Workshop/components/Dashboard';
import Workshops from './pages/Workshop/components/Workshop';
import Analytics from './pages/Workshop/components/Analytics';
import Community from './pages/Workshop/components/Community';
import UsersManagement from './pages/Workshop/components/Users';
import Settings from './pages/Workshop/components/Settings';
import EmailManagement from './pages/Workshop/components/EmailManagement';
import AdminLayout from './components/AdminLayout';
import WorkshopCategory from "./pages/Workshop/components/Category";
import LandingPage from "./pages/ThoughtCoCreate/LandingPage";
import WinnersPage from "./pages/ThoughtCoCreate/TCCWinner";
import ProfileSetupPage from "./pages/UserProfile/EditProfile";
import EduEcoSystem from "./pages/EduEcoSystem/page";
import TCCWhitePaper from "./pages/TCCWhitePaper/TCCWhitePaper";
// const Home = lazy(() => import('./pages/Home'));
// const PackageManagement = lazy(() => import('./pages/PackageManagement'));

// const LoadingComponent = () => <div>Loading...</div>; // Custom loading component
// const SuspenseWrapper = (...props:React.LazyExoticComponent<React.FC<{}>>[]) => {
//   return <Suspense fallback={<LoadingComponent />}>
//   {props.map((Element)=>{
//     return <Element />
//   })}
// </Suspense>
// }

function App() {

  useEffect(() => {
    // Thêm script Google Tag Manager vào head nếu chưa có
    if (!document.getElementById("google-tag-script")) {
      const script = document.createElement("script");
      script.id = "google-tag-script";
      script.async = true;
      script.src = "https://www.googletagmanager.com/gtag/js?id=G-33RY6CB20Y";
      document.head.appendChild(script);

      const scriptInline = document.createElement("script");
      scriptInline.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'G-33RY6CB20Y');
      `;
      document.head.appendChild(scriptInline);
    }
  }, []);

  return (
    <>
      <ThoughtCoCreateProvider>
        <SiteAlertProvider>
          <AvatarProvider>
            <WorkshopProvider>
              <BrowserRouter>
                <Routes>
                  <Route path="/">
                    <Route path="educator-workspace" Component={Layout}>
                        {/* <Route index Component={Distributor}  /> */}
                        <Route index  Component={()=>{
                          return <Navigate to="dashboard" />
                        }} />
                        <Route path="dashboard">
                          <Route index Component={EducatorDashboard}></Route>
                        </Route>
                        <Route path="my-thoughtcocreate">
                          <Route index Component={MyThoughtCoCreate} />
                          <Route path="dashboard">
                            <Route index Component={SubmissionsDashboard}></Route>
                          </Route>
                          <Route path="deliverable">
                            <Route index Component={SubmissionsDashboard}></Route>
                            <Route path=":id">
                              <Route index Component={Deliverable} />
                            </Route>
                          </Route>
                        </Route>
                        <Route path="my-learning-tools">
                          <Route index Component={LearningTool}></Route>
                        </Route>
                        <Route path="my-twinspace" Component={TwinspaceLayout}>
                          <Route index Component={Twinspace}></Route>
                        </Route>
                        <Route path="my-profile" Component={UserProfileLayout}>
                          <Route index Component={UserProfile}></Route>
                          <Route path="edit">
                            <Route index Component={ProfileSetupPage} />
                          </Route>
                        </Route>
                        <Route path="forum">
                          <Route path=":id">
                            <Route index Component={ForumDetail} />
                          </Route>
                          <Route path="discussion">
                            <Route path=":id">
                              <Route index Component={DiscussionDetail} />
                            </Route>
                          </Route>
                        </Route>

                        <Route path="my-courses">
                          <Route index Component={AllCoursesPage}  />
                        </Route>
                        
                    </Route>
                    <Route path="educator-register" Component={EducatorRegisterLayout}>
                      <Route index Component={RegisterForm}  />
                    </Route>
                    <Route path="tcc-scoring-system" Component={TCCScoringSystemLayout}>
                      <Route index Component={ScoringSystem}  />
                      <Route path="results">
                        <Route index Component={ResultSummary}  />
                      </Route>
                    </Route>
                    <Route path="thoughtcocreate" Component={ThoughtCoCreateLayout}>
                      <Route index Component={LandingPage}  />
                      <Route path="rules-and-guidelines" Component={RulesAndGuidelinesLayout}>
                        <Route index Component={RulesAndGuidelinesPage}  />
                      </Route>
                    </Route>
                    <Route path="participants" Component={EducatorRegisterLayout}>
                      <Route index Component={Dashboard}  />
                    </Route>
                    <Route path="summit-finalist">
                      <Route index Component={TCCSummitFinalistPage}  />
                    </Route>
                    <Route path="tcc-summit-2025">
                      <Route index Component={TCCSummitLanding}  />
                    </Route>
                    <Route path="educatalyst" Component={EducatalystLayout}>
                      <Route index Component={WorkshopHub}  />
                      <Route path="creation" Component={WorkshopCreation} />
                      <Route path="detail/:id">
                        <Route index Component={WorkshopDetail}  />
                      </Route>
                      <Route path="detail-proposal/:id">
                        <Route index Component={ProposalDetail}  />
                      </Route>
                      <Route path="edit/:id">
                        <Route index Component={EditWorkshop}  />
                      </Route>
                    </Route>
                    <Route path="workshop-management" element={<AdminLayout />}>
                      <Route index element={<Navigate to="dashboard" />} />
                      <Route path="dashboard" element={<Dashboard2 />} />
                      <Route path="workshops" element={<Workshops />} />
                      <Route path="category" element={<WorkshopCategory />} />
                      <Route path="community" element={<Community />} />
                      <Route path="users" element={<UsersManagement />} />
                      <Route path="email-template" element={<EmailManagement />} />
                      <Route path="analytics" element={<Analytics />} />
                      <Route path="settings" element={<Settings />} />
                      <Route path="workshops/:id" element={<WorkshopAdminDetail />} />
                    </Route>
                    <Route path="tcc-winner" >
                      <Route index Component={WinnersPage}  />
                    </Route>
                    <Route path="tcc-whitepaper-2025">
                      <Route index Component={TCCWhitePaper}  />
                    </Route>
                    <Route path="">
                      <Route index Component={EduEcoSystem}/>
                    </Route>
                  </Route>
                </Routes>
              </BrowserRouter>
            </WorkshopProvider>
          </AvatarProvider>
        </SiteAlertProvider>
        
      </ThoughtCoCreateProvider>
    </>
  );
}

export default App;
